module.exports = __webpack_public_path__ + "static/media/spelling-01.f27df122.jpg";